<template>
  <div class="signHeader">
    <div class="header">
      <img src="@/assets/imgs/pdf.svg" alt="" class="header-img" />
      <div class="header-info">
        <div class="name">{{ file.contractName }}</div>
        <div class="extra">
          <span class="status" :class="'status' + file.isFinish">{{
            file.isFinish ? '待签署' : '已签署'
          }}</span>
        </div>
      </div>
      <div v-if="fileList.length > 1" class="header-change" @click="onSelect">
        更换
        <span class="icon" :class="isShowSelect ? 'icon2' : ''"></span>
      </div>
    </div>
    <ul
      class="select"
      :style="{
        opacity: isShowSelect ? 1 : 0,
        maxHeight: isShowSelect ? '300px' : 0,
      }"
    >
      <li
        class="select-item"
        v-for="(item, index) in fileList"
        :key="index"
        :class="contractNum === item.contractNum ? 'active-item' : ''"
        @click="onChange(item)"
      >
        {{ item.contractName }}
      </li>
    </ul>
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    data() {
      return {
        isShowSelect: false,
      }
    },
    computed: {
      ...mapState({
        signInfo: state => state.sign,
      }),
      ...mapGetters({
        file: 'sign/file',
      }),
      contractNum() {
        return this.signInfo.contractNum
      },
      fileList() {
        return this.signInfo.list
      },
    },
    methods: {
      onSelect() {
        this.isShowSelect = !this.isShowSelect
      },
      onChange(item) {
        this.onSelect()
        this.$store.commit('sign/changeFile', { contractNum: item.contractNum })
      },
    },
  }
</script>
<style lang="less" scoped>
  .signHeader {
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 375px;
    height: 68px;
    background: #f4f5f6;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    .header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .header-img {
        width: 36px;
        margin-right: 8px;
      }
      .header-info {
        flex: 1;
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 8px;
        .name {
          font-size: 14px;
          color: #1f2023;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .extra {
          margin-top: 4px;
          display: flex;
          align-items: center;
          .status {
            padding: 2px 8px;
            border-radius: 2px;
            font-size: 10px;
            font-weight: 500;
            &.status0 {
              background: #feeeec;
              color: #ff6e48;
            }
            &.status1 {
              background: #ebf3ff;
              color: #1676ff;
            }
          }
        }
      }
      .header-change {
        font-size: 12px;
        display: flex;
        align-items: center;
        color: #434751;
        .icon {
          margin-top: 5px;
          margin-left: 5px;
          border: 5px solid #434751;
          border-color: #434751 transparent transparent transparent;
        }
        .icon2 {
          margin-top: -5px;
          margin-left: 5px;
          border-color: transparent transparent #434751 transparent;
        }
      }
    }
    .select {
      position: absolute;
      transition: all 0.4s;
      top: 58px;
      left: 16px;
      width: 343px;
      z-index: 999;
      // height: 130px;
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0px 6px 10px 0px rgba(230, 234, 237, 0.3);
      overflow: hidden;
      overflow-y: scroll;
      -webkit-overflow-scrolling: auto !important;
      .select-item {
        width: 343px;
        padding: 10px;
        // height: 40px;
        background: #fff;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        // text-align: center;
        color: #5f6368;
        // line-height: 40px;
        white-space: nowrap;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .active-item {
        background-color: #ebf3ff;
      }
    }
  }
</style>
